import React from "react";

import {
  ActionButton,
  BottomActionSheet,
  CancelButton,
  HeaderLabel,
  HeaderSubtitle,
  HeaderTitle,
  SheetCard,
  SheetHeader,
} from "../../../../../../components/BottomActionSheet";
import { DateFormat, formatDate } from "../../../../../../utils";
import { AccountActionSheetProps } from "./types";

export const AccountActionSheet: React.FC<AccountActionSheetProps> = ({
  account,
  isOpen,
  isDeleting,
  isUpdatingStatus,
  onClose,
  onEdit,
  onDelete,
  onStatusChange,
}) => {
  const statusLabel = account.isActive ? "Active" : "Inactive";
  const subtitleParts = [
    formatDate(account.startDate, DateFormat.DMY_SPACE),
    statusLabel,
  ].filter(Boolean);
  const subtitle = subtitleParts.join(" · ");
  const statusActionLabel = account.isActive ? "Deactivate" : "Reactivate";

  const runAction = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <BottomActionSheet
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Account actions"
    >
      <SheetCard>
        <SheetHeader $column>
          <HeaderLabel>Account</HeaderLabel>
          <HeaderTitle>{account.name}</HeaderTitle>
          {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
        </SheetHeader>
        <ActionButton
          type="button"
          $centered
          onClick={() => runAction(() => onEdit(account))}
        >
          Edit
        </ActionButton>
        <ActionButton
          type="button"
          $centered
          $variant="warn"
          disabled={isUpdatingStatus}
          onClick={() => runAction(onStatusChange)}
        >
          {statusActionLabel}
        </ActionButton>
        <ActionButton
          type="button"
          $centered
          $variant="destructive"
          disabled={isDeleting}
          onClick={() => runAction(onDelete)}
        >
          Delete
        </ActionButton>
      </SheetCard>
      <SheetCard>
        <CancelButton type="button" onClick={onClose}>
          Cancel
        </CancelButton>
      </SheetCard>
    </BottomActionSheet>
  );
};
